import { type QueryCache } from '@kaiizen/react-persistent-cache';
import { createSubscriptionChangeHandler, type RealtimeClient } from './RealtimeClient';

const REFETCH_REASON = 'refetch';

const isOwnRealtimeEvent = (payload: unknown, currentSessionId?: string) => {
  if (!currentSessionId || !payload || typeof payload !== 'object') return false;
  const actorSessionId = 'actorSessionId' in payload ? payload.actorSessionId : undefined;
  return typeof actorSessionId === 'string' && actorSessionId === currentSessionId;
};

const refetchByPrefix = (queryCache: QueryCache<unknown>, prefix: string) => {
  queryCache.refetchAll({
    prefix,
    reason: REFETCH_REASON,
  });
};

export const createScanDataSubscriptionChangeHandler = (
  realtimeClient: RealtimeClient,
  options?: { currentSessionId?: string },
) =>
  createSubscriptionChangeHandler(realtimeClient, (queryCache, key, payload) => {
    if (isOwnRealtimeEvent(payload, options?.currentSessionId)) return;
    refetchByPrefix(queryCache, key);
  });
